/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var UIUtil = require('psa-core/util/ui');
var GridView = require('psa-marionette/views/GridView');

var ConfirmationModalView = require('common/views/ConfirmationModalView');
var MultiButtonCell = require('common/backgrid/MultiButtonCell');
var DollarCell = require('common/backgrid/DollarCell');
var MomentCell = require('common/backgrid/MomentCell');

var SubmitInvestmentHistory = require('../services/SubmitInvestmentHistory');

module.exports = GridView.extend({
  className: 'corp-fin-inv-history-section-view',

  onBeforeRender: function() {
    if (GridView.prototype.onBeforeRender) {
      GridView.prototype.onBeforeRender.apply(this.arguments);
    }

    var isReadOnly = this.options.isReadOnly;

    this.options.columns = [
      {
        name: 'filingNumber',
        label: 'Filing Code',
        cell: 'string',
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'transactionDescription',
        label: 'Transaction Description',
        cell: 'string',
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'status',
        label: 'Status',
        cell: 'string',
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'PADollarAmount',
        label: 'PA Offering Amount',
        cell: DollarCell,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'feePaidAmountDisplay',
        label: 'Fee Paid Amount',
        cell: DollarCell,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'filedDate',
        label: 'Filed Date',
        cell: MomentCell.MomentCell,
        formatter: MomentCell.MomentDateFormatter.extend({
          emptyValue: '--'
        }),
        sortValue: MomentCell.MomentSortValue,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'dispositionDate',
        label: 'Disposition Date',
        cell: MomentCell.MomentCell,
        formatter: MomentCell.MomentDateFormatter.extend({
          emptyValue: '--'
        }),
        sortValue: MomentCell.MomentSortValue,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'effectiveFromDate',
        label: 'Effective From',
        cell: MomentCell.MomentCell,
        formatter: MomentCell.MomentDateFormatter.extend({
          emptyValue: '--'
        }),
        sortValue: MomentCell.MomentSortValue,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'effectiveToDate',
        label: 'Effective To',
        cell: MomentCell.MomentCell,
        formatter: MomentCell.MomentDateFormatter.extend({
          emptyValue: '--'
        }),
        sortValue: MomentCell.MomentSortValue,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'editDeleteMultiButtonCell',
        label: '',
        width: 10,
        cell: MultiButtonCell.extend({
          buttons: [
            {
              name: '',
              labelClass: 'fa fa-edit',
              buttonClass: 'btn-primary btn-sm edit-inv-history',
              href: function(model) {
                return (
                  '#corpfin/investment/' +
                  model.get('investmentId') +
                  '/investment-history/' +
                  model.get('id') +
                  '/edit'
                );
              },
              renderable: function() {
                return !isReadOnly;
              }
            },
            {
              name: '',
              labelClass: 'fa fa-trash',
              buttonClass: 'btn-danger btn-sm delete-inv-history',
              onClick: this.onClickDeleteHistory.bind(this),
              renderable: function() {
                return !isReadOnly;
              }
            }
          ]
        }),
        editable: false,
        sortable: false
      }
    ];
    this.options.emptyText = 'No Investment History';
  },

  onClickDeleteHistory: function(e, model) {
    e.preventDefault();
    var self = this;
    var message = 'Are you sure you want to delete this investment history?';
    UIUtil.showModal({
      title: 'Confirm Deleting Investment History',
      view: new ConfirmationModalView({
        confirmText: 'Delete Investment History',
        model: new Backbone.Model({
          message: message,
          onConfirm: function() {
            var investmentHistoryId = model.get('id');
            return SubmitInvestmentHistory({ investmentHistoryId: investmentHistoryId, isDeleted: '1' });
          },
          onConfirmDone: function() {
            self.collection.remove(model);
          }
        })
      })
    });
  }
});
